import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanActionPlanFiles } from 'src/bean/BeanActionPlanFiles';
import { BeanParecer } from 'src/bean/BeanParecer';
import { BeanPlanoDeAcao } from 'src/bean/BeanPlanoDeAcao';
import { environment } from 'src/environments/environment';

@Injectable()

export class ParecerPlanoDeAcaoService {


    selectedIndex: number = 0;

    constructor(
        private http: HttpClient
    ){ }


    public getUsuarioPorId(id:number):Promise<any>{
        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.get(environment.urlBackend + environment.getUsuarioById + "/" + id, { headers : headers})
        .toPromise().then(
                (resposta:any) => resposta    );
    }

    


    public getListcmbOperacao():Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.get(environment.urlBackend + environment.listarCadastroOperacoesAtivos, { headers : headers})
        .toPromise().then(
                (resposta:any) => resposta    );
    }


    public listarStatusPlanoAcao() : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };
        
        //console.log(environment.urlBackend +  environment.listarStatusPlanosDeAcoes)

        return this.http.get(environment.urlBackend +  environment.listarStatusPlanosDeAcoes, {headers}).toPromise().then((resposta:any) => resposta)

    }

    public addAnexo(beanMonitoryFiles: BeanActionPlanFiles): Promise<any> {
        const tokenString = localStorage.getItem('access_token');
    
        const headers = {
          'Authorization': 'Bearer ' + tokenString,
          'Content-Type': 'application/json'
        };
        let json = JSON.stringify(beanMonitoryFiles);
        return this.http.post(`${environment.urlBackend}${environment.anexarArquivoPlanoDeAcao}`, json, { headers }).toPromise();
      }

    public deletarAnexo(moanIdCdMonitoriaAnexo: string) {
        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization': 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
        };
        return this.http.delete(environment.urlBackend + environment.deletarArquivoPlanoDeAcao + moanIdCdMonitoriaAnexo, { headers })
    }

    public buscarAnexo(moniIdCdMonitoria: string): Promise<any> {
        const tokenString = localStorage.getItem('access_token');
    
        const headers = {
          'Authorization': 'Bearer ' + tokenString,
          'Content-Type': 'application/json'
        };
        return this.http.get(environment.urlBackend + environment.buscarNomeArquivoPlanoDeAcao + moniIdCdMonitoria, { headers }).toPromise()
      }

    public downloadAnexo(plaaIdCdPlanoacaoanexo: number): Promise<any> {
        const tokenString = localStorage.getItem('access_token');
    
        const headers = {
          'Authorization': 'Bearer ' + tokenString,
          'Content-Type': 'application/json'
        };
        return this.http.get(environment.urlBackend + environment.downloadArquivoPlanoDeAcao + plaaIdCdPlanoacaoanexo, { headers }).toPromise()
      }

    public listarMes() : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };
        
        //console.log(environment.urlBackend +  environment.listarStatusPlanosDeAcoes)

        return this.http.get(environment.urlBackend +  environment.listarMeses, {headers}).toPromise().then((resposta:any) => resposta)

    }

    
    public listarSituacao() : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarSituacaoPorOperacoes, {headers}).toPromise().then((resposta:any) => resposta)

    }


    
    inativarPlanoAcao(formModel: BeanPlanoDeAcao):Promise<any>{
        return this.excluirPlanoAcao(formModel).toPromise().then((resposta:any) => resposta);
    }
    
    
    public excluirPlanoAcao(formModel: BeanPlanoDeAcao):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        let json = JSON.stringify(formModel);

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.put(environment.urlBackend + environment.inativarActionplan + "/" +formModel.placIdCdPlanoacao+"/",  json, { headers : headers});

    }




    public listarGestao(idOperacao : string) : Promise<any>{

        const tokenString = localStorage.getItem('access_token');
        let idTipoDeUsuarioGestor = "2"

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarGertorPorEmpresa + "/"+idOperacao + "/"+idTipoDeUsuarioGestor, {headers}).toPromise().then((resposta:any) => resposta)

    }



    public listarPlanosDeAcoesPorOperacoes(idOperacao : string) : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarPlanosDeAcoesPorEmpresa +"/"+ idOperacao, {headers}).toPromise().then((resposta:any) => resposta)

    }



    public listarParecer() : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarParecer, {headers}).toPromise().then((resposta:any) => resposta)

    }

    addPlanoDeAcao(formModel: BeanPlanoDeAcao):Promise<any>{
        return this.gravarPlanoDeAcao(formModel).toPromise().then((resposta:any) => resposta);
    }

    public gravarPlanoDeAcao(formModel: BeanPlanoDeAcao):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        let json = JSON.stringify(formModel);


        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.post(environment.urlBackend + environment.criarActionplan, json, {headers: headers});
    }


    addParecer(formModel: BeanParecer):Promise<any>{
        return this.gravarParecer(formModel).toPromise().then((resposta:any) => resposta);
    }

    public gravarParecer(formModel: BeanParecer):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        let json = JSON.stringify(formModel);


        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.post(environment.urlBackend + environment.criarSeem, json, {headers: headers});
    }


    updatePlanoAcao(formModel: BeanPlanoDeAcao):Promise<any>{
        return this.atualizarUsuario(formModel).toPromise().then((resposta:any) => resposta);
    }

    public atualizarUsuario(formModel: BeanPlanoDeAcao):Observable<any> {
        const tokenString = localStorage.getItem('access_token');

        let json = JSON.stringify(formModel);

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.put(environment.urlBackend + environment.updatActionplan + "/" +formModel.placIdCdPlanoacao +"/",  json, { headers : headers});

    }



    updateParecer(formModel: BeanParecer):Promise<any>{
        return this.atualizarParecer(formModel).toPromise().then((resposta:any) => resposta);
    }


    public atualizarParecer(formModel: BeanParecer):Observable<any> {
        const tokenString = localStorage.getItem('access_token');

        let json = JSON.stringify(formModel);

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.put(environment.urlBackend + environment.updateSeem + "/" +formModel.pareIdCdParecer +"/",  json, { headers : headers});

    }

}
